module.exports = __webpack_public_path__ + "a54720a0273d42f6a15ba7c968dc9134.jpg";